/* eslint-disable import/no-anonymous-default-export */
export default (adminIssuedMonthlyCost = [], action) => {
  switch (action.type) {
    case "ADMIN_STOCK_ISSUED_YEARLY":
      return action.payload;

    default:
      return adminIssuedMonthlyCost;
  }
};
